/* NutroTonic site header — ported from Meditonic's mt-header.js, kept unminified.
   Boots per [data-nt-head] instance and re-boots on shopify:section:load. */
(function () {
  var d = document;

  function boot(head) {
    if (head.ntBooted) return;
    head.ntBooted = true;

    var burger = head.querySelector('[data-nt-menu]'),
        panel = d.getElementById(head.dataset.ntPanel || 'nt-nav-panel'),
        cartBtn = head.querySelector('[data-nt-cart]'),
        countEl = head.querySelector('[data-nt-cart-count]'),
        ticking = false,
        /* Bars above the header differ per template: the homepage and collections show
           only the promo bar, PDPs also render a countdown bar above it (DOM order is
           timer -> promotion-bar -> navigation). Rather than hardcode that list, measure
           the spacer: the header is fixed so it occupies no flow, which means the
           spacer's document top IS the combined height of everything above. New bars are
           handled for free. */
        spacer = head.parentNode ? head.parentNode.querySelector('.nt-head-spacer') : null,
        barsH = 0;

    function measure() {
      /* offsetHeight 0 means the spacer is hidden — layouts that want the header to
         float over a full-bleed hero (the nt-2026 preview) do that. Without this guard
         a mid-scroll remeasure would read rect.top 0 and set barsH to the scroll
         position, making the header jump. */
      if (!spacer || spacer.offsetHeight === 0) { barsH = 0; return; }
      barsH = spacer.getBoundingClientRect().top + (window.pageYOffset || 0);
      if (!(barsH > 0)) barsH = 0;
    }
    function paint() {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
      var top = Math.max(0, barsH - window.scrollY);
      head.style.setProperty('--nth-top', top + 'px');
      /* also on :root — the sheet is a sibling of the header and must pad for the same
         offset, or the pill lands on top of the search field on bar-heavy templates */
      d.documentElement.style.setProperty('--nth-top', top + 'px');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    /* remeasure whenever the bars can change height, not just on load */
    window.addEventListener('resize', function () { measure(); paint(); });
    if (window.ResizeObserver && spacer) {
      try { new ResizeObserver(function () { measure(); paint(); }).observe(d.body); } catch (e) {}
    }
    measure(); paint();
    /* the countdown bar and promo bar can render late; recheck once fonts/images settle */
    window.addEventListener('load', function () { measure(); paint(); });
    setTimeout(function () { measure(); paint(); }, 900);

    if (burger && panel) {
      var items = panel.querySelectorAll('.nt-nav__link, .nt-nav__shop, .nt-nav__foot');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--nth-d', (0.06 + i * 0.045).toFixed(3) + 's');
      }

      var open = function () {
        panel.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        d.body.classList.add('nt-nav-open');
        var sheet = panel.querySelector('.nt-nav__sheet');
        if (sheet) setTimeout(function () { sheet.focus(); }, 180);
      };
      var close = function (focusBack) {
        panel.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        d.body.classList.remove('nt-nav-open');
        if (focusBack) burger.focus();
      };

      burger.addEventListener('click', function () {
        panel.classList.contains('is-open') ? close(false) : open();
      });
      var scrim = panel.querySelector('[data-nt-close]');
      if (scrim) scrim.addEventListener('click', function () { close(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('is-open')) close(true);
      });
      /* focus trap */
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], lastEl = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && d.activeElement === lastEl) { e.preventDefault(); first.focus(); }
      });
      panel.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) close(false);
      });
    }

    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove('is-bumped');
        void cartBtn.offsetWidth;            /* reflow so the animation can retrigger */
        cartBtn.classList.add('is-bumped');
      }
      last = n;
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
        .catch(function () { /* leave the server-rendered count */ });
    }
    refresh();
    /* this theme ships the Kaching drawer; catch the events it and Dawn-style themes emit */
    d.addEventListener('cart-drawer:refresh', function () { setTimeout(refresh, 400); });
    d.addEventListener('cart:updated', function () { setTimeout(refresh, 300); });
    d.addEventListener('ajaxCart.afterCartLoad', function () { setTimeout(refresh, 300); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 200); }); } catch (e) {}
    }
  }

  function run() {
    d.querySelectorAll('[data-nt-head]').forEach(function (el) {
      try { boot(el); } catch (e) { if (window.console) console.warn('nt-head:', e); }
    });
  }
  d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', run) : run();
  d.addEventListener('shopify:section:load', run);
})();
